import React from 'react';
import { useLocation } from 'react-router-dom';

// Tela temporária exibida enquanto o módulo ainda não foi implementado
// Será substituída pela tela real de cada módulo

function EmBreve() {
  const location = useLocation();

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '400px',
      fontFamily: "'Manrope', sans-serif",
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '60px', height: '60px', borderRadius: '50%',
          backgroundColor: '#eff6ff',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 16px',
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
              stroke="#003399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a2e', marginBottom: '8px' }}>
          Em desenvolvimento
        </h2>
        <p style={{ fontSize: '13px', color: '#888', maxWidth: '280px' }}>
          Este módulo será implementado em breve. Rota: <code style={{ color: '#003399' }}>{location.pathname}</code>
        </p>
      </div>
    </div>
  );
}

export default EmBreve;
